import React, { useEffect } from 'react';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import { useAdminAuth } from './useAdminAuth';
import './Admin.css';

export default function AdminApp() {
  const { authed, login, logout, error, busy } = useAdminAuth();

  useEffect(() => {
    document.title = 'C-Kan · Admin';
  }, []);

  return authed
    ? <AdminDashboard onLogout={logout} />
    : <AdminLogin onLogin={login} error={error} busy={busy} />;
}
